import { ArticleHeading4 } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import * as styles from '../styles.css';

interface IJournalSidebarItemProps {
  title: string;
  img: string;
  onClick: () => void;
}

export const JournalSidebarItem: React.FC<IJournalSidebarItemProps> = ({ title, img, onClick }) => {
  return (
    <div className={styles['item']} onClick={onClick}>
      <ArticleHeading4>{title}</ArticleHeading4>

      <div className={cn(styles['img'], styles[img])} />
    </div>
  );
};
